import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    "vf-trace-transaction-id": crypto.randomUUID(),
    ...commonRequestHeaders(),
  };
};

export const encrypt = async (data) => {
  const response = await axios.post(
    `${PROCESS_AUTOMATION_SERVICE_URL}/utils/crypto/encrypt`,
    { data },
    {
      headers: {
        ...getHeaders(),
        "Content-Type": "application/json",
      },
    },
  );
  return response.data.result;
};

export const decrypt = async (data) => {
  const response = await axios.post(
    `${PROCESS_AUTOMATION_SERVICE_URL}/utils/crypto/decrypt`,
    { data },
    {
      headers: {
        ...getHeaders(),
        "Content-Type": "application/json",
      },
    },
  );
  return response.data.result;
};
